function isEmail(value) {
  if (!value) return true;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
}

function isPhone(value) {
  if (!value) return true;
  return /^[+()\d\s-]{6,20}$/.test(String(value).trim());
}

function hasErrors(errors) {
  return Object.keys(errors).length > 0;
}

export function validateCustomer(form) {
  const errors = {};
  if (!form.name || !String(form.name).trim()) errors.name = '必填';
  if (form.email && !isEmail(form.email)) errors.email = '邮箱格式不正确';
  if (form.phone && !isPhone(form.phone)) errors.phone = '电话格式不正确';
  return errors;
}

export function validateVendor(form) {
  const errors = {};
  if (!form.name || !String(form.name).trim()) errors.name = '必填';
  if (form.email && !isEmail(form.email)) errors.email = '邮箱格式不正确';
  if (form.phone && !isPhone(form.phone)) errors.phone = '电话格式不正确';
  return errors;
}

export function validateItem(form) {
  const errors = {};
  if (!form.name || !String(form.name).trim()) errors.name = '必填';
  return errors;
}

export function validateTransaction(form) {
  const errors = {};
  if (!form.itemName || !String(form.itemName).trim()) errors.itemName = '请选择商品';
  if (form.quantity === '' || isNaN(Number(form.quantity))) errors.quantity = '数量必须为数字';
  if (form.quantity !== '' && Number(form.quantity) <= 0) errors.quantity = '数量必须为正数';
  if (!form.customerVendorName || !String(form.customerVendorName).trim()) errors.customerVendorName = '请选择往来方';
  if (!form.transactionType) errors.transactionType = '请选择交易类型';
  if (form.total === '' || isNaN(Number(form.total))) errors.total = '合计必须为数字';
  if (form.total !== '' && Number(form.total) < 0) errors.total = '合计不能为负数';
  return errors;
}

export { hasErrors };
